import React, {Component} from 'react';
import Translator from 'src/requests/apa/Translator';
import './styles.scss';
import Utils from 'src/utils/Utils';

class NewSectionInfoChannel extends Component {
     constructor(props) {
        super(props);
        this.colorButton = Translator.get('Color_ColorPrimario')
        this.colorPromotionText = Translator.get('Color_ColorTextoPromocion')
    }

     componentDidMount() {
        Utils.querySelectorSafe('.aaf_header-compound-header-logo', (backButton) => {
            backButton.classList.add('channel-info-section__back-button');
        });

        Utils.querySelectorSafe('.aaf_colored-button-yellow-principal', (anchorButton) => {
            anchorButton.style.backgroundColor = Translator.get('Color_ColorSecundario');
        });

        Utils.querySelectorSafe('.left-container', (infoContainer) => {
            infoContainer.classList.add('channel-info-section__container');
        });
    }

    getPrice = (currency, price, producttype) => {
        const metadataText = Translator.get(`LandingComercial_TextoPrecio1_${producttype}`);
        return metadataText
            .replace(/@currency/g, currency)
            .replace(/@price/g, price);
    }

    render() {

        const [offer1] = this.props.offers;
        const {onClick} = this.props;
        const {currency, producttype, price, provider, landingBonus} = offer1 || {};

        return (
            <div className='channel__info-section'>
                <h2 className='info-section__title'>
                    {Utils.cutPlayerString(Translator.get(`LandingComercial_TextoNombreAddOn_${producttype}`), 27)}
                </h2>
                <p className={`info-section__offer-description`}>
                    {Utils.cutPlayerString(Translator.get(`LandingComercial_Texto1_${producttype}`), 147)}
                </p>

                <div>
                    <p className={`info-section__promotion-text`}>
                        <span style={{color: this.colorPromotionText}}>{Translator.get(`LandingComercial_TextoPromo1_${producttype}`)}</span>
                        {' '}{Utils.cutPlayerString(Translator.get(`LandingComercial_TextoPromo2_${producttype}`), 15)}
                    </p>
                </div>

                 <div>
                    <p className={`info-section__price`}>
                        <span  className='info-section__price--fs48 info-section__price--fw700'>
                             {Utils.cutPlayerString(this.getPrice(currency, price, producttype), 15)}
                        </span>
                        <span>
                            {Utils.cutPlayerString(Translator.get(`LandingComercial_TextoImpuestos1_${producttype}`), 21)}
                        </span>
                    </p>
                </div>

                <div>
                    <button 
                        className={`info-section__button focusable`}
                        style={{ backgroundColor: this.colorButton }} 
                        onClick={() => onClick((producttype || provider), landingBonus && landingBonus.label)}
                    >
                        {Utils.cutPlayerString(Translator.get(`LandingComercial_TextoBoton1_${producttype}`), 21)}
                    </button>
                </div>

                 <div className={`info-section__cancel-text`}>
                    {Utils.cutPlayerString(Translator.get(`LandingComercial_Texto4_${producttype}`), 123)}
                </div>
                
            </div>
        )
    }

}

export default NewSectionInfoChannel


// WEBPACK FOOTER //
// ./src/payments/DetailSelector/newSectionInfoChannel/NewSectionInfoChannel.jsx